import {
  CURRENT_LANGUAGE,
  Language,
  TranslationEntity,
} from '@seaters/constants';

export type TransObjectType = {
  [lang in Language]: string;
};

export const translationsParser = (
  transObject: TransObjectType
): TranslationEntity[] => {
  const langArray = Object.keys(transObject) as Language[];
  const parsedData = langArray.map(
    (key: Language): TranslationEntity => ({
      lang: key,
      text: transObject[key],
    })
  );

  return parsedData;
};

export const getSingleTranslation = (
  data: TranslationEntity[],
  lang?: string
): string => {
  const newData = (Array.isArray(data) ? data : []).map((dataItem) => {
    return { lang: dataItem.lang, text: dataItem.text ? dataItem.text : null };
  });
  return (
    newData?.find((translation) => {
      return lang
        ? translation.lang === lang
        : translation.lang === CURRENT_LANGUAGE;
    })?.text ??
    newData?.find((translation) => {
      return translation.lang === Language.EN;
    })?.text ??
    ''
  );
};

export const getSingleRangeOptionTranslation = (
  data: TranslationEntity[],
  lang?: string
): string => {
  const newData = (Array.isArray(data) ? data : []).map((dataItem) => {
    return { lang: dataItem.lang, text: dataItem.text ? dataItem.text : null };
  });
  return newData
    ?.find((translation) => {
      return lang
        ? translation.lang === lang
        : translation.lang === CURRENT_LANGUAGE;
    })
    ?.text?.split(' - ')[1]
    ? newData?.find((translation) => {
        return lang
          ? translation.lang === lang
          : translation.lang === CURRENT_LANGUAGE;
      })?.text ?? ''
    : newData
        ?.find((translation) => {
          return translation.lang === Language.EN;
        })
        ?.text?.split(' - ')[1]
    ? newData?.find((translation) => {
        return translation.lang === Language.EN;
      })?.text ?? ''
    : '';
};
